module.exports = __webpack_public_path__ + "static/media/homepage_battle_section.695b1618.png";